/*
    Модель для работы с режимами рисования
*/

/*
    Решил объединить состояния включения рисования.

    TODO: что делать с логикой, которая запускается при выключении?
*/

const initialState = {
    /*
        Включен некий default режим
    */
    isDefault: true,
    /*
        Включен режим рисования rappers
    */
    isRappersDraw: false,
    /*
        Включен режим рисования interval
    */
    isIntervalDraw: false,
    /*
        Включен режим рисования interval для экспорта
    */
    isExportIntervalDraw: false,
};

export const tabletDrawingModel = {
    name: 'tabletDrawing',
    state: initialState,
    reducers: {
        setDefault: () => {
            return { isDefault: true, isRappersDraw: false, isIntervalDraw: false, isExportIntervalDraw: false };
        },
        setRappersDraw: () => {
            return { isDefault: false, isRappersDraw: true, isIntervalDraw: false, isExportIntervalDraw: false };
        },
        setIntervalDraw: () => {
            return { isDefault: false, isRappersDraw: false, isIntervalDraw: true, isExportIntervalDraw: false };
        },
        setExportIntervalDraw: () => {
            return { isDefault: false, isRappersDraw: false, isIntervalDraw: false, isExportIntervalDraw: true };
        },
    },
    effects: {},
    selectors: {},
};
